import React from "react";

export const LogoIcon = (
  <svg
    version="1.1"
    id="Layer_1"
    xmlns="http://www.w3.org/2000/svg"
    x="0px"
    y="0px"
    viewBox="0 0 25 25"
  >
    <path
      d="M15.7,24.3c-0.1,0-0.1,0-0.2,0c-2,0-4,0-6,0c-0.2,0-0.3-0.1-0.3-0.2c-3-7.7-6-15.5-9-23.2C0.1,0.7,0.1,0.7,0.4,0.7
	c1.9,0,3.7,0,5.6,0c1.1,0,1.7,0.5,2.1,1.5c2.5,7.3,5,14.6,7.6,21.9C15.6,24.1,15.7,24.2,15.7,24.3z M16.5,22.4c2-5.2,4-10.3,6-15.5
	c0.1-0.3,0-0.3-0.2-0.3c-1.6,0-3.3,0-4.9,0c-0.9,0-1.7,0.5-2,1.4c-0.7,2-1.3,4-2,6c-0.1,0.2-0.1,0.4,0,0.5c0.9,2.5,1.7,5,2.6,7.5
	c0.1,0.2,0.2,0.4,0.3,0.7C16.4,22.7,16.4,22.6,16.5,22.4z M22.7,5.6c0.2,0,0.3,0,0.3-0.2c0.6-1.5,1.2-3,1.7-4.5
	c0.1-0.2,0.1-0.3-0.2-0.3c-1.8,0-3.7,0-5.5,0c-0.8,0-1.5,0.5-1.7,1.3c-0.4,1.1-0.7,2.3-1.1,3.4c-0.1,0.2,0,0.3,0.2,0.3
	c1,0,2.1,0,3.1,0C20.6,5.6,21.7,5.6,22.7,5.6z"
    />
  </svg>
);

export const LogoAltIcon = (
  <svg
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    x="0px"
    y="0px"
    viewBox="0 0 25 25"
  >
    <path
      className="st0"
      style={{ fill: "#0E0662" }}
      d="M15.7,24.3c-0.1,0-0.1,0-0.2,0c-2,0-4,0-6,0c-0.2,0-0.3-0.1-0.3-0.2c-3-7.7-6-15.5-9-23.2
	C0.1,0.7,0.1,0.7,0.4,0.7c1.9,0,3.7,0,5.6,0c1.1,0,1.7,0.5,2.1,1.5c2.5,7.3,5,14.6,7.6,21.9C15.6,24.1,15.7,24.2,15.7,24.3z"
    />
    <path
      className="st1"
      style={{ fill: "#6D6D6D" }}
      d="M16.5,22.4c2-5.2,4-10.3,6-15.5c0.1-0.3,0-0.3-0.2-0.3c-1.6,0-3.3,0-4.9,0c-0.9,0-1.7,0.5-2,1.4
	c-0.7,2-1.3,4-2,6c-0.1,0.2-0.1,0.4,0,0.5c0.9,2.5,1.7,5,2.6,7.5c0.1,0.2,0.2,0.4,0.3,0.7C16.4,22.7,16.4,22.6,16.5,22.4z M22.7,5.6
	c0.2,0,0.3,0,0.3-0.2c0.6-1.5,1.2-3,1.7-4.5c0.1-0.2,0.1-0.3-0.2-0.3c-1.8,0-3.7,0-5.5,0c-0.8,0-1.5,0.5-1.7,1.3
	c-0.4,1.1-0.7,2.3-1.1,3.4c-0.1,0.2,0,0.3,0.2,0.3c1,0,2.1,0,3.1,0C20.6,5.6,21.7,5.6,22.7,5.6z"
    />
  </svg>
);
